export const MOVIES_ACTION_TYPES = {
  FETCH_MOVIES_START: "FETCH_MOVIES_START",
  FETCH_MOVIES_POPULAR: "FETCH_MOVIES_POPULAR",
  FETCH_MOVIES_FAILED: "FETCH_MOVIES_FAILED",
  FETCH_MOVIES_TRENDING: "FETCH_MOVIES_TRENDING",
  FETCH_TV_TRENDING: "FETCH_TV_TRENDING",
  FETCH_MOVIES_TOP_RATED: "FETCH_MOVIES_TOP_RATED",
  FETCH_MOVIES_UPCOMING: "FETCH_MOVIES_UPCOMING",
  FETCH_POPULAR_TV_SHOWS: "FETCH_POPULAR_TV_SHOWS",
  FETCH_TOP_RATED_TV_SHOWS: "FETCH_TOP_RATED_TV_SHOWS",
};
